module.exports = __webpack_public_path__ + "static/img/top-shine.f449d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/activity/three-order-activity/top-shine.png
// module id = zS/w
// module chunks = 4